module.exports = __webpack_public_path__ + "static/media/location.a3ba413f.svg";